export const PrivacyConsent = "PrivacyConsent";
export const EmployeeAwareConsent = "EmployeeAwareConsent";
export const DataSecureConsent = "DataSecureConsent";
export const SelfReferral = "SelfReferral";
export const LineManagerName = "LineManagerName";
export const LineManagerEmail = "LineManagerEmail";
export const LineManagerPhone = "LineManagerPhone";
export const HrName = "HrName";
export const HrEmail = "HrEmail";
export const PurchaseOrderNumber = "PurchaseOrderNumber";
export const ReferredTitle = "ReferredTitle";
export const ReferredFirstName = "ReferredFirstName";
export const ReferredLastName = "ReferredLastName";
export const ReferredDob = "ReferredDob";
export const ReferredGender = "ReferredGender";
export const EmployeeId = "EmployeeId";
export const JobTitle = "JobTitle";
export const AddressLine1 = "AddressLine1";
export const AddressLine2 = "AddressLine2";
export const AddressLine3 = "AddressLine3";
export const City = "City";
export const County = "County";
export const Postcode = "Postcode";
export const PersonalEmailAddress = "PersonalEmailAddress";
export const ConfirmPersonalEmailAddress = "ConfirmPersonalEmailAddress";
export const MobilePhone = "MobilePhone";
export const HomePhone = "HomePhone";
export const WorkPhone = "WorkPhone";
export const OrgLevel1Id = "OrgLevel1Id";
export const OrgLevel1Name = "OrgLevel1Name";
export const OrgLevel2Id = "OrgLevel2Id";
export const OrgLevel2Name = "OrgLevel2Name";
export const OrgLevel3Id = "OrgLevel3Id";
export const OrgLevel3Name = "OrgLevel3Name";
export const OrgLevel4Id = "OrgLevel4Id";
export const OrgLevel4Name = "OrgLevel4Name";
export const ShiftPattern = "ShiftPattern";
export const StandardHours = "StandardHours";
export const PrivateMedicalInsurance = "PrivateMedicalInsurance";
export const EmployeeAssistedProgramme = "EmployeeAssistedProgramme";
export const Physiotherapy = "Physiotherapy";
export const Absent = "Absent";
export const AbsenceStart = "AbsentStart";
export const PreviouslyReferred = "PreviouslyReferred";
export const RestrictedDuties = "RestrictedDuties";
export const RestrictedDutiesDetails = "RestrictedDutiesDetails";
export const Recurrent = "Recurrent";
export const Prolonged = "Prolonged";
export const MentalHealth = "MentalHealth";
export const MusculoSkeletal = "MusculoSkeletal";
export const FitnessForWork = "FitnessForWork";
export const FitnessForDisciplinary = "FitnessForDisciplinary";
export const Accident = "Accident";
export const RequirementsChanged = "RequirementsChanged";
export const PoorPerformance = "PoorPerformance";
export const AlcoholOrDrugMisuse = "AlcoholOrDrugMisuse";
export const IllHealthRetirement = "IllHealthRetirement";
export const AbsenceReason = "AbsenceReason";
export const WorkRelated = "WorkRelated";
export const ReturnDate = "ReturnDate";
export const RestrictionsApply = "RestrictionsApply";
export const AdjustmentsRequired = "AdjustmentsRequired";
export const EqualityAct = "EqualityAct";
export const FitToContinue = "FitToContinue";
export const FitForDisciplinary = "FitForDisciplinary";
export const ReliableInFuture = "ReliableInFuture";
export const ImpairedPerformance = "ImpairedPerformance";
export const ReferToSpecialist = "ReferToSpecialist";
export const AdditionalInfo = "AdditionalInfo";
export const FaceToFaceAttend = "FaceToFaceAttend";
export const TelephoneDiscussion = "TelephoneDiscussion";
export const ProlongedStanding = "ProlongedStanding";
export const ProlongedSitting = "ProlongedSitting";
export const Driving = "Driving";
export const Walking = "Walking";
export const Climbing = "Climbing";
export const ShiftWork = "ShiftWork";
export const HeavyLifting = "HeavyLifting";
export const Twisting = "Twisting";
export const Pulling = "Pulling";
export const Pushing = "Pushing";
export const Dse = "Dse";
export const ConfinedSpace = "ConfinedSpace";
export const Chemicals = "Chemicals";
export const BiologicalAgents = "BiologicalAgents";
export const Machinery = "Machinery";
export const DustOrFumes = "DustOrFumes";
export const NoiseHazards = "NoiseHazards";
export const OutsideWork = "OutsideWork";
export const OverseasTravel = "OverseasTravel";
export const WorkplaceStress = "WorkplaceStress";
export const OtherRoleFunctions = "OtherRoleFunctions";
export const TotallyConfidential = "TotallyConfidential";
export const SeparateAdditionalQuestionAnswersRequired = "SeparateAdditionalQuestionAnswersRequired";
export const SupportingDocumentsHeader = "SupportingDocumentsHeader";
